/**
 * lot DJ5 — barre du haut : les quatre boutons (Tâches, Favoris, Diffusion, cloche) partagent
 * exactement la même mise en forme. Icône colorée + petit libellé, libellé masqué sur tablette.
 */
export const BOUTON_BARRE = 'group relative flex flex-col items-center justify-center gap-0.5 '
  + 'h-11 w-11 md:h-10 md:w-10 lg:h-[46px] lg:w-auto lg:min-w-[58px] lg:px-2.5 rounded-lg transition-all '
  + 'hover:bg-white hover:shadow-[0_1px_2px_rgba(15,23,42,.08)]';

export const LIBELLE_BARRE = 'hidden lg:block text-[11px] font-medium leading-none '
  + 'text-[#475569] group-hover:text-[#0F172A]';

export const PASTILLE_BARRE = 'absolute top-[1px] right-[4px] min-w-[18px] h-[18px] px-1 '
  + 'rounded-full text-[10px] font-bold flex items-center justify-center text-white';
